export default "__VITE_ASSET__BkimIz4D__"